module.exports = __webpack_public_path__ + "media/images/icon-square-228101fad12fc12b3ef89cb13f1c8d2b.svg";